import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip, Typography } from "antd";
import classNames from "classnames";
import { I18N_NS } from "Config/i18n";
import { plankeyFormStore } from "Pages/Project/Settings/Stores/GeneralFormStore";
import { useTranslation } from "react-i18next";
import { projectsDataStore } from "Stores/ProjectsStore";

interface LedIndicatorsProps {
  functions: API_PROJECT_FUNCTIONS[];
}

export const LedIndicators = ({ functions = [] }: LedIndicatorsProps) => {
  const { t } = useTranslation(I18N_NS.COMPONENT_UPLOAD);

  const handleDownloadFilename = () => {
    plankeyFormStore.downloadFile(projectsDataStore.filenameConvDoc);
  };

  const config: { [key in API_PROJECT_FUNCTIONS]?: string } = {
    FILENAMECHECK: "led-light",
    METADATA: "led-light",
    AUTOMATICDIRMAPPING: "led-light",
  };

  functions?.reduce((buffer, current) => {
    if (current === "FILENAMECHECK" || current === "METADATA" || current === "AUTOMATICDIRMAPPING") {
      buffer[current] += " led-on";
    }
    return buffer;
  }, config);

  const renderFilenameLedLink = () => (
    <>
      <Tooltip title={t("The file that describes the filename rules in the project")} className="led-info">
        <FontAwesomeIcon icon={["far", "download"]} />
      </Tooltip>
      <div onClick={handleDownloadFilename} className="pointer">
        <Typography.Text underline>{t("Filename convention")}</Typography.Text>
      </div>
    </>
  );

  return (
    <div>
      <div className="led-indicator">
        {projectsDataStore.filenameConvDoc ? renderFilenameLedLink() : <div>{t("Filename convention")}</div>}
        <div className={config.FILENAMECHECK} />
      </div>
      <div className="led-indicator">
        <div>{t("Add meta data")}</div>
        <div className={config.METADATA} />
      </div>
      <div className="led-indicator">
        <div>{t("Automatic directory mapping")}</div>
        <div className={config.AUTOMATICDIRMAPPING} />
      </div>
    </div>
  );
};

interface WorkflowLedIndicatorsProps {
  metadataIsOn: boolean;
  filenameRulesIsOn?: boolean;
  accessRight?: API_FILELISTREST_ACCESS;
}

export const WorkflowLedIndicators = ({ metadataIsOn, accessRight, filenameRulesIsOn }: WorkflowLedIndicatorsProps) => {
  const { t } = useTranslation(I18N_NS.COMPONENT_UPLOAD);

  return (
    <div>
      <p className="text-right">
        <b>{t("For this step:")}</b>
      </p>
      <div className="led-indicator">
        <div className="led-title">{t("Filename rules of Doc. module")}</div>
        <div className={classNames("led-light", { "led-on": filenameRulesIsOn })} />
      </div>
      <div className="led-indicator">
        <div className="led-title">{t("Add meta data")}</div>
        <div className={classNames("led-light", { "led-on": metadataIsOn })} />
      </div>
      <div className="led-indicator">
        <div className="led-title">{t("Overwrite ex. files")}</div>
        <div className={classNames("led-light", { "led-on": accessRight === "WRITEOWN" })} />
      </div>
    </div>
  );
};
